var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from './styled-components';
var View = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  padding: 0;\n  margin: 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  padding: 0;\n  margin: 0;\n"])));
export default View;
var templateObject_1;
